var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Box',[_c('div',{staticClass:"menu"},_vm._l((_vm.tabsArray),function(item){return _c('div',{key:item.id,staticClass:"menu__item",class:_vm.getClass(item),attrs:{"data-id":item.id},on:{"click":function($event){return _vm.select(item.id)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }